import { IResource } from 'interfaces/resources';
import { generateResources } from 'utils/GenerateResouces';

const resource: IResource = {
  name: 'graduate_courses_enrollment',
  label: 'Matrículas de cursos regulados',
  actions: ['list', 'show', 'edit'],
  parentName: 'students_teachers',
  onlyPermission: true
};

export default generateResources(resource);
